<template lang="pug">

  transition(name="fade")

    #share
      h2 Share
      ul
        li.fb
          a(@click="onFacebookClick" href="#" :aria-label="lang_en['site-aria-tag-facebook-share-link']" )
            fb-svg
        li.twitter
          a(@click="onTwitterClick" href="#" :aria-label="lang_en['site-aria-tag-twitter-share-link']")
            twitter-svg

</template>

<script>

import gsap from 'gsap' 
import { mapState, mapMutations, mapGetters } from 'vuex'
import { PATHS, HOME, MODAL_STATES } from 'src/config/app'
import { twitter, facebook } from 'src/helpers/Share'
import FbSvg from 'src/assets/svgs/facebook_icon.svg'
import TwitterSvg from 'src/assets/svgs/twitter_icon.svg'

export default {

  components: {
    FbSvg,
    TwitterSvg
  },

  data() {
    return {}
  },

  props: {
    theme: {
      type: String,
      default: 'white'
    }
  },

  computed: {

    ...mapState('app', [
      'home',
      'modal_state',
      'motion_clamp'
    ]),

    url(){
      return this.lang_en['meta-site-url']
    },

    twitter_share_copy(){
      return this.lang_en['share-twitter-title']
    }
  },

  created(){ },

  mounted() {
    this.$el.classList.toggle('dark', this.theme === 'dark')
  },

  beforeDestroy() {},

  methods: {

    onFacebookClick(){
      facebook.share({url: this.url})
    },

    onTwitterClick(){
      twitter.share({url: this.url, text: this.twitter_share_copy})
    },

    enter(duration = 1, delay = 0){ 
      gsap.to(this.$el, (duration * this.motion_clamp), {
        opacity: 1,
        delay: (delay * this.motion_clamp)
      })
    },

    leave(){ 
      gsap.to(this.$el, 0.5, {
        opacity: 0
      })
    }
  },

  watch: {

  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#share
  opacity: 0
  display: flex
  align-items: center
  justify-content: center

  ul
    display: flex
    align-items: center
    justify-content: center
    color: white

  &.dark
    color: #373C85
    li
      svg
        fill: #373C85


  h2
    font-size: 1.3rem
    font-family: "Regular"

  li
    position: relative
    height: 1.8rem
    margin: 0 0.7rem

    a
      width: 100%
      height: 100%
      display: flex
      align-items: center
      transition: transform 0.3s ease-out, opacity 0.3s ease-out
      opacity: 1
      outline: none

      &:hover,
      &:focus
        transition: transform 0s ease-out
        opacity: 0.5
        transform: scale(1.25)

    &.title
      display: flex
      align-items: center


    &.twitter
      height: 1.4rem


    svg
      height: 100%
      position: relative
      display: block
      fill: white

</style>
